import { useAuthStore } from '~/stores/auth'

// Initialize authentication state on app start
export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return
  if (!nuxtApp.$pinia) return

  const auth = useAuthStore(nuxtApp.$pinia)
  // Warm auth state without blocking initial page render (LCP).
  void auth.loadMe().catch((error) => {
    console.warn('[auth] Initial loadMe failed:', error)
  })
})
